export const CHECK_SESSION = "check_session";
export const LIST_ADMIN = "list_admin";
export const MODIFY_ADMIN = "modify_admin";
export const DELETE_ADMIN = "delete_admin";
export const FIND_ADMIN = "find_admin";
export const UPDATE_ADMIN = "update_admin";
export const REGISTER_ADMIN = "register_admin";
export const LOGIN_ADMIN = "login_admin";
export const AUTH_ADMIN = "auth_admin";
export const LOGOUT_ADMIN = "logout_admin";
export const FIND_SENSOR = "find_sensor";
export const FIND_SENSORID = "find_sensorid";
export const UPDATE_SENSORID = "update_sensorid";
export const FIND_USER = "find_user";
export const UPDATE_USER = "update_user";
export const REGISTER_USER = "register_user";
export const FIND_GATEWAY = "find_gateway";
export const UPDATE_GATEWAY = "update_gateway";
export const FIND_SETTING = "find_setting";
export const UPDATE_SETTING = "update_setting";
export const REGISTER_SETTING = "register_setting";
export const FIND_DEVICE = "find_device";
export const UPDATE_DEVICE = "update_device";
export const UPDATE_STATEDEVICE = "update_statedevice";
export const REGISTER_DEVICE = "register_device";
export const DELETE_DEVICE = "delete_device";
export const LIST_USER = "list_user";
export const DELETE_USER = "delete_user";
export const SEARCH_LIST = "search_list";
export const SEARCH_DEVICE = "search_device";
export const DEVICE_LIST = "device_list";
export const MODIFY_USER = "modify_user";
export const UPDATE_SENSOR = "update_sensor";
export const UPDATE_POWER = "update_power";

export const LOGIN_USER = "login_user";
export const AUTH_USER = "auth_user";
export const LOGOUT_USER = "logout_user";

export const HOME_REALTIME = "home_realtime";
export const HOME_GRAPH = "home_graph";
export const HOME_STATUS_RESET = "home_status_reset";
export const HOME_GRAPH_PRINT = "home_graph_print";
export const SETTING_ALERT_UPDATE = "setting_alert_update";
export const SETTING_TERM_UPDATE = "setting_term_update";
